import React, {useEffect, useState } from 'react';
import styles from '../../styles/modules/components/SelfServe/service-request-success.module.scss'
import { connect } from 'react-redux';
import Image from '../common/Image';
import { getParamsObjectFromString, getStaticPath } from "../../utils";
import { successPage } from '../../tracking/selfserveTracking';
import Moment from 'moment';
import router from 'next/router'
import { setToast } from "../../redux/actions/genericActions";
import { useDispatch } from "react-redux";
import Button from '../common/ui-components/input/Button';
import { isCopayAfterSr } from '../../utils/selfserve';

interface ReduxStateProps {
    selfserveReducer: any,
}

type Props = ReduxStateProps

const ServiceRequestSuccess = (props: Props) => {
    const dispatch:any = useDispatch()
    const [appRender, setAppRender] = useState<boolean>(false)
    const [appointment_time_slot, set_appointment_time_slot] = useState([])
    const [date, setDate] = useState('')
    const [time , setTime] = useState('')
    useEffect(() => {
        successPage(); //gtm tracking event
        window.scrollTo({top:0,left:0,'behavior': 'smooth'});

        if(getParamsObjectFromString(window.location.href)['urlParams']['app_render'] === "true"){
            setAppRender(true)
          }
    }, [])

    React.useEffect(() =>{
        if(props.selfserveReducer?.sucessData?.data?.appointment_time_slot){
            let appointment_time_slot = props.selfserveReducer?.sucessData?.data?.appointment_time_slot.split(',');
            set_appointment_time_slot(appointment_time_slot)
            let date = appointment_time_slot[0].trim()!=='' ? Moment(appointment_time_slot[0].trim(), 'DD/MM/YYYY').format('DD MMM YYYY') : ''
            setDate(date)
            let time = appointment_time_slot[1] || ''
            setTime(time)
        }
    },[props.selfserveReducer?.sucessData?.data?.appointment_time_slot])
    const disclaimers = props.selfserveReducer?.sucessData?.data?.disclaimers;
    const refNo = props.selfserveReducer?.sucessData?.data?.ticket_creation_ref_id
    const deviceName = props.selfserveReducer?.sucessData?.data?.device_model
    const serviceType = props.selfserveReducer?.sucessData?.data?.service_type;
    const planName = props.selfserveReducer?.planDetails?.plan_name;
    const issueSelected = props.selfserveReducer?.sucessData?.data?.issue_text;
    const addressInfo = [props.selfserveReducer?.sucessData?.data?.address_info?.address, `${props.selfserveReducer?.sucessData?.data?.address_info?.city}, ${props.selfserveReducer?.sucessData?.data?.address_info?.state}-${props.selfserveReducer?.sucessData?.data?.address_info?.pincode}`];
    const contactInfo = [props.selfserveReducer?.sucessData?.data?.contact_info?.name, props.selfserveReducer?.sucessData?.data?.contact_info?.email, props.selfserveReducer?.sucessData?.data?.contact_info?.phone];
    const appointmentSlotPreference = props.selfserveReducer?.sucessData?.data?.sla_description;
    const process_type = props.selfserveReducer?.sucessData?.data?.process_type
    const payment_url = props.selfserveReducer?.sucessData?.data?.payment_url || null

     const copyToClipboard = (text) => {
        navigator.clipboard.writeText(payment_url)
        dispatch(setToast({ showToast: true, message: "Link copied successfully" }))
      };
    return (
            <div className={styles.container}>
                <div className={styles._img}>
                    <Image src={getStaticPath(`/static/images/selfserve/success.png`)} quality={100} alt="Success" width="100" height="100" unoptimized={true}/>
                </div>
                <h5>Service Request Created Successfully</h5>
                <div className={styles.container_head}>
                    <div className={styles.track_service_request} onClick={() => {
                                if (appRender) { window.open(props.selfserveReducer.sucessData.data.track_your_device+"?app_render=true", "_self", "noopener,noreferrer"), window.opener = null}
                                else { window.open(props.selfserveReducer.sucessData.data.track_your_device, "_blank", "noopener,noreferrer"), window.opener = null }
                    }}>
                        <div className={styles.service_request_number}>SR No: {refNo}</div>
                        <div className={styles.service_request_tracker}>Track Request</div>
                    </div>
                    {isCopayAfterSr(router) && payment_url && <Button text="Copy Payment Link" onClick={copyToClipboard} className={styles.payment_link_copy}/>}
                    <p><span>Things to Note:</span></p>
                </div>
                <div className={`container ${styles.container_parent}`}>
                    <div className={`${styles.container_content} row`}>
                        <div className={`${styles.reasons_parent} col-12 col-lg-8`}>
                            {
                                disclaimers && disclaimers.map((disclaimer,i) =>
                                    <div className={styles.reasons} key={i} dangerouslySetInnerHTML={{ __html: disclaimer}}>
                                </div>
                                    )
                            }
                        </div>
                        <div className={`${styles.sr_details} col-12 col-lg-4`}>
                            <div className={styles.sr_detail_group}>
                                <div className={styles.sr_detail_title}><span>Device/Appliance:</span></div>
                                <div className={styles.sr_detail_content}>{deviceName}</div>
                            </div>
                        { (serviceType)&&(planName !="Air Conditioner Service") &&
                            <div className={styles.sr_detail_group}>
                                <div className={styles.sr_detail_title}><span>Service Type:</span></div>
                                <div className={styles.sr_detail_content}>{serviceType}</div>
                            </div>
                        }
                            { (planName !="Air Conditioner Service" && process_type !== "Theft") &&
                                <div className={styles.sr_detail_group}>
                                    <div className={styles.sr_detail_title}><span>Issues Reported:</span></div>
                                    {issueSelected && issueSelected.map((issue) => {
                                        return <div className={styles.sr_detail_content}>{issue}</div>
                                    })}
                                </div>
                            }
                            { (planName !="Air Conditioner Service" && process_type !== "Theft") &&
                            <div className={styles.sr_detail_group}>
                                <div className={styles.sr_detail_title}><span>Appointment Details:</span></div>
                                <div className={styles.sr_detail_content}>{props.selfserveReducer.appointmentProcessType.processType === 'AMC' && appointment_time_slot.length > 0 && date && time? `${date}, ${time}` : appointmentSlotPreference ? appointmentSlotPreference: '' }</div>
                            </div>
                            }
                            { process_type !== "Theft" &&<div className={styles.sr_detail_group}>
                                <div className={styles.sr_detail_title}><span>Contact Details:</span></div>
                                {contactInfo.filter(item =>item !==null).map((item) => {
                                    return <div className={styles.sr_detail_content}>{item}</div>
                                })}
                            </div>}
                            <div className={styles.sr_detail_group}>
                                <div className={styles.sr_detail_title}><span>Address Details:</span></div>
                                {addressInfo.filter(item =>item !==null).map((item) => {
                                    return <div className={styles.sr_detail_content}>{item}</div>
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

const mapStateToProps = (state: any) => {
    return {
        selfserveReducer: state.selfserveReducer,
    }
}

export default connect<ReduxStateProps>(mapStateToProps)(ServiceRequestSuccess);